import {
  KineticModule,
  PrivilegeType,
  useCameraDetectionStatusQuery,
  useUpdateCameraDetectionStatusMutation,
} from '@kinetic-ui/data-layer';
import { MenuItem, Select, Tooltip, Typography } from '@mui/material';
import useCameraDetailsOverlayStyles from 'components/CameraDetailsOverlay/styles';
import { useAllPrivileges } from 'kineticUtils';
import L from 'leaflet';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CameraIrisFocusControlsProps } from '../types';

export interface CameraCapabilitiesProps extends CameraIrisFocusControlsProps {
  detectionsMenuRef: React.RefObject<HTMLDivElement>;
}
const detectionOptions = ['enabled', 'disabled'];

const CameraDetections: React.FunctionComponent<CameraCapabilitiesProps> = (props) => {
  const classes = useCameraDetailsOverlayStyles();
  const { t } = useTranslation(['video', 'common']);
  const hasManageDetectionsPrivilege = useAllPrivileges(
    [PrivilegeType.ManageDetections],
    KineticModule.Video
  );
  const { data, controlsButtonRef, setShowControls, detectionsMenuRef } = props;
  const { data: detectionStatus } = useCameraDetectionStatusQuery({
    variables: { cameraId: data.id },
  });
  const [updateCameraDetectionStatus] = useUpdateCameraDetectionStatusMutation();
  if (!hasManageDetectionsPrivilege || !detectionStatus?.cameraDetectionStatus.isSupported) {
    return null;
  }
  return (
    <>
      <div className={classes.cameraControls} key={`cameraDetectionsDiv_${data.id}`}>
        <Tooltip
          placement='top'
          PopperProps={{ container: controlsButtonRef.current }}
          title={t(`common:detections`)}
        >
          <Typography fontSize='small' variant='body1' className={classes.controlText}>
            {t(`common:detections`)}
          </Typography>
        </Tooltip>
        <Select
          onChange={(event) => {
            event.stopPropagation();
            const enabled = event.target.value === detectionOptions[0];
            updateCameraDetectionStatus({ variables: { cameraId: data.id, enable: enabled } });
            setShowControls(false);
          }}
          onWheel={(event) => {
            L.DomEvent.stopPropagation(event as unknown as Event);
            event.stopPropagation();
          }}
          id={`detectionsSelect_$${data.id}`}
          className={classes.capabilitiesSelectInput}
          classes={{
            icon: classes.capabilitiesSelectIcon,
          }}
          MenuProps={{
            ref: detectionsMenuRef,
            classes: { list: classes.capabilitiesList },
          }}
          label={'common:detections'}
          value={
            detectionStatus?.cameraDetectionStatus?.enabled
              ? detectionOptions[0]
              : detectionOptions[1]
          }
        >
          {detectionOptions?.map((option) => (
            <MenuItem
              key={`detectionsSelectOption_${data.id}_${option} `}
              value={option ?? undefined}
            >
              {t(`common:${option}`)}
            </MenuItem>
          ))}
        </Select>
      </div>
    </>
  );
};

export default CameraDetections;
